import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class DoNotDisturb {
  static isEternal(until) {
    return moment.utc(until).isSame(DoNotDisturb.forever, "day");
  }
}
_defineProperty(DoNotDisturb, "forever", "3000-01-01T00:00:00.000Z");